"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MirandaResort = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Options_1 = require("../Options");
var MirandaResort = (function (_super) {
    __extends(MirandaResort, _super);
    function MirandaResort() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.MIRANDA_RESORT,
            tags: [Tags_1.Tags.JOVIAN, Tags_1.Tags.SPACE],
            cost: 12,
            metadata: {
                cardNumber: '051',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.megacredits(1).slash().earth(1, { played: Options_1.played });
                    });
                }),
                description: 'Increase your M€ production 1 step for each Earth tag you have.',
                victoryPoints: 1,
            },
        }) || this;
    }
    MirandaResort.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, player.getTagCount(Tags_1.Tags.EARTH), { log: true });
        return undefined;
    };
    MirandaResort.prototype.getVictoryPoints = function () {
        return 1;
    };
    return MirandaResort;
}(Card_1.Card));
exports.MirandaResort = MirandaResort;
